/**
 * Home은 webbapp이 보여지는 페이지이며, React는 아무것도 렌더링하지 않는다.
 */
const Home: React.FC = () => {
  return <></>;
};

export default Home;
